import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { resolveTotpChallenge } from './mfa.js';
import { validateTotpCode, normalizeTotpCode, getAuthErrorCode, mapMfaErrorMessage, } from './mfaPure.js';
import { mfaCard, mfaCardWrap, mfaTitle, mfaSubtitle, mfaForm, mfaLabel, mfaInput, mfaError, mfaButton, mfaSecondaryButton, } from './mfaStyles.js';
/**
 * S-75: TOTP 第二要素の challenge フォーム。
 *
 * SignInPage が `attemptEmailPasswordSignIn` の結果 `mfa-required` を受けたときに描画する。
 * 解決に成功すると resolver 内部でサインインが完了し、onAuthStateChanged が発火して
 * 各 app の AuthProvider が signed-in に遷移する（このコンポーネントは自身では遷移しない）。
 */
export function MfaChallenge({ resolver, onCancel, header }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    async function onSubmit(e) {
        e.preventDefault();
        const v = validateTotpCode(code);
        if (v) {
            setError(v);
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await resolveTotpChallenge(resolver, normalizeTotpCode(code));
            // 成功 → onAuthStateChanged が発火し本コンポーネントは unmount される。
        }
        catch (err) {
            setError(mapMfaErrorMessage(getAuthErrorCode(err)));
        }
        finally {
            // 成功時は unmount 済みで no-op。失敗 / 想定外に mount が残った場合に
            // ボタンを再操作可能に戻す（「確認中…」固着を防ぐ）。
            setSubmitting(false);
        }
    }
    return (_jsx("main", { style: mfaCardWrap, children: _jsxs("div", { style: mfaCard, children: [header, _jsx("h1", { style: header ? { ...mfaTitle, marginTop: '1rem' } : mfaTitle, children: "2 \u6BB5\u968E\u8A8D\u8A3C" }), _jsx("p", { style: mfaSubtitle, children: "\u8A8D\u8A3C\u30A2\u30D7\u30EA\uFF08Google Authenticator \u7B49\uFF09\u306B\u8868\u793A\u3055\u308C\u305F 6 \u6841\u306E\u30B3\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" }), _jsxs("form", { style: mfaForm, onSubmit: onSubmit, noValidate: true, children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "mfa-code", style: mfaLabel, children: "\u78BA\u8A8D\u30B3\u30FC\u30C9" }), _jsx("input", { id: "mfa-code", inputMode: "numeric", autoComplete: "one-time-code", maxLength: 12, placeholder: "123456", required: true, value: code, onChange: (e) => setCode(e.target.value), style: mfaInput, "aria-invalid": Boolean(error), "aria-describedby": error ? 'mfa-code-error' : undefined, autoFocus: true })] }), error && (_jsx("p", { id: "mfa-code-error", role: "alert", style: mfaError, children: error })), _jsx("button", { type: "submit", disabled: submitting, style: mfaButton(submitting), children: submitting ? '確認中…' : '確認' }), onCancel && (_jsx("button", { type: "button", onClick: onCancel, style: mfaSecondaryButton, children: "\u30B5\u30A4\u30F3\u30A4\u30F3\u306B\u623B\u308B" }))] })] }) }));
}
//# sourceMappingURL=MfaChallenge.js.map